// The Tone Count is controlled by the SASS and is outputted as a CSS Variable.
var toneCount = null;
function initialiseAll() {
    const body = $('body');
    // Get tone count.
    toneCount = body.css('--site-colour-tones-count');
    // Initialise colour pallete.
    initialiseColourPallete();
    // Initialise heading property display.
    initialiseCSSProperties();
}

// Display heading css properties.
function initialiseCSSProperties() {
    // Get context.
    let context = $('[' + expressSelectors()['style-guide']['css-properties'] + ']');
    if (context.length > 0) {
        context.find('[' + expressSelectors()['style-guide']['property'] + ']').each(function() {
            // Element context.
            let element = $(this);
            let container = element.parent('div');
            // Allow the user to specify exactly where in DOM to output properties.
            let outputContainer = element.attr('property-container');
            // Various properties.
            let fontSize = element.css('font-size');
            let fontWeight = element.css('font-weight');
            let fontFamily = element.css('font-family');
            let colour = rgb2hex(element.css('color'));
            let textTransform = element.css('text-transform');

            // Build property viewer.
            let markup = `
                    <p><span class='item-info-label'>CSS Property Viewer:</span></p>
                    <ul>
                        <li>Font Size: ${fontSize}</li>
                        <li>Font Weight: ${fontWeight}</li>
                        <li>Font Family: ${fontFamily}</li>
                        <li>Colour: ${colour}</li>
                        <li>Text Transform: ${textTransform}</li>
                    </ul>
            `;

            // Check if this item already has a dedicated info container.
            let sgInfoContainer = container.find('.sg-item-information-container');
            // If so then add css properties to that container instead of creating a new area.
            if (sgInfoContainer.length > 0) {
                // Add markup to DOM.
                container.find('.sg-item-information-container').append(markup);
            } else if (outputContainer) {
                markup = `<div class="css-property-view">${markup}</div>`
                $('#' + outputContainer).append(markup);
            } else {
                markup = `<div class="css-property-view">${markup}</div>`
                // Add markup to DOM.
                container.append(markup);
            }

            
            

        });
    }
}

// Display Colour pallette properties.
function initialiseColourPallete() {
    let context = $('[' + expressSelectors()['style-guide']['colour-pallette'] + ']');
    if (context.length > 0) {
        context.find('.colour-block').each(function() {
            // Get the context of the colour block container.
            let block = $(this);
            // Colour block context.
            let colour = block.find('[' + expressSelectors()['style-guide']['colour-preview'] + ']');
            // Use the class as its name.
            let name = colour.attr('class');
            // Get hex value.
            let hex = rgb2hex(colour.css('background-color'));
            // Is this colour using the automated colour scaling mechanism.
            if (name.includes('lightness')) {
                // Get lightness from string.
                let lightness = name.split("lightness-");
                // Because we work in increments of 10%.
                lightness = (lightness[1] * toneCount);
                // Remove the lightness percentage from 100%, easier for people who work with opacity.
                lightness = (100 - lightness);
                // Stores a description about the colour ( i.e the change ).
                let title = "";
                if (lightness != 100) {
                    // As its impossible to get 0% of the a base tone due to clamping tone scaling to it never results in either black or white the final value will always be 5%.
                    if (!lightness) {
                        lightness = 5 + "&percnt;";
                        
                    } else {
                        lightness = lightness + "&percnt;";
                    }
                    title = `${lightness} lightness of base colour`;
                    
                } else {
                    lightness = "Base Colour";
                    title = "Original colour";
                }
                // Update DOM.
                block.append(`<span class="lightened-percentage" title="${title}">${lightness}</span>`);
            }
            // Update block with name of label + hex value.
            block.append(`<span class="colour-name-label" title="CSS Variable reference">${name}</span>`);
            block.append(`<span class="colour-hex-label" title="Hex Value">${hex}</span>`)

        });
    }
}


var styleguide = $.styleguide = {
    initialiseAll: () => {
        return initialiseAll();
    }
}
 
export { styleguide };
